/*
 * @Author: Json Chen
 * @Date: 2021-06-25 14:07:11
 * @LastEditTime: 2021-06-30 17:23:04
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ProductAttributeDefaultModalForm.tsx
 */

import React from 'react';
import { Form, Modal } from 'antd';
import styles from '../style.module.less';
import { randomNumber } from '@/src/tools/helper';
import ShowExistValue from './ShowExistValue';
import useResetFormOnCloseModal from '@/src/hooks/useResetFormOnCloseModal';
import ProductAttributeDropdownOptions from './ProductAttributeDropdownOptions';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ShowDefaultAttributeOptions = ({ defaultOptions, inputKey }) => {
  return defaultOptions ? (
    <div className={styles.unchangeable}>
      <div className={styles.title}>Default Attribute Options</div>
      <div className={styles.content}>
        {defaultOptions.map((item, index) => (
          <span key={item.uuid}>
            {index > 0 ? ' , ' : null}
            {item[inputKey]}
          </span>
        ))}
      </div>
    </div>
  ) : null;
};

const PriceTierModalForm = ({
  visible,
  attrData,
  attrIndex,
  onCancel,
  onModalConfirm,
}: {
  // 弹窗是否展示
  visible: boolean;
  // 编辑时,默认的内容
  attrIndex: number;
  // 关闭弹窗
  onCancel: () => void;
  onModalConfirm: (data: any) => void;
  attrData?: any;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [form] = Form.useForm();
  const [modalTitle, setModalTitle] = React.useState<string>('');
  const [confirmDisable, setConfirmDisable] = React.useState<boolean>(false);
  const {
    title = '',
    options = [],
    inputKey = '',
    defaultOptions,
    newOptionName,
  } = attrData[attrIndex] || {
    title: getI18n('storeProductSetting.detail.attribute'),
    newOptionName: getI18n('storeProductSetting.detail.attributeOptions'),
  };

  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onOk = () => {
    form.validateFields().then((res) => {
      onModalConfirm(
        attrData.map((item, index) => {
          if (attrIndex === index) {
            return { ...item, ...res };
          }
          return item;
        }),
      );
    });
  };
  React.useEffect(() => {
    setModalTitle(getI18n('storeProductSetting.detail.editDefault'));
    form.setFieldsValue({
      title: title,
      options: options.map((item) => ({
        ...item,
        draggableId: randomNumber(),
      })),
    });
  }, [attrIndex]);

  const addOption = () => {
    const currentOptions = form.getFieldValue('options');

    form.setFieldsValue({
      options: currentOptions.concat({
        [inputKey]: `${newOptionName} ${currentOptions.length + 1}`,
        deletable: true,
        draggableId: randomNumber(),
      }),
    });
  };

  return (
    <Modal
      forceRender={true}
      title={modalTitle}
      visible={visible}
      okButtonProps={{
        disabled: confirmDisable,
      }}
      okText={getI18n('general.confirm')}
      cancelText={getI18n('general.cancel')}
      maskClosable={false}
      width={600}
      wrapClassName={styles.modalContainer}
      onOk={onOk}
      onCancel={onCancel}>
      <Form
        form={form}
        layout='vertical'
        name='productAttrDefaultModalForm'
        className={styles.productAttrModalForm}>
        <Form.Item
          name='title'
          className={styles.input}
          label={
            <div className={styles.inputLabel}>
              <div className={styles.inputLableTitle}>
                {getI18n('storeProductSetting.detail.attributeTitle')}*
              </div>
            </div>
          }
          rules={[{ required: true }]}>
          <ShowExistValue />
        </Form.Item>

        <ShowDefaultAttributeOptions
          defaultOptions={defaultOptions}
          inputKey={inputKey}
        />

        <ProductAttributeDropdownOptions
          {...{
            defaultOptions,
            inputKey,
            setConfirmDisable,
            addOption,
          }}
        />
      </Form>
    </Modal>
  );
};

export default PriceTierModalForm;
